import { Product } from './product';

export class Brand {
    brandId: number;
    name: string;
    products: Array<Product>;
 
    constructor(brandId?: number,  name?: string, products?: Array<Product>) { 
        this.brandId  = brandId || 0;
        this.name = name || "";
        this.products =  products || new Array<Product>();
    }
}

